import {
    getAxiosFulfilledState,
    getPendingState,
    getRejectedState,
    getSettingsState,
    resetState,
} from '../helpers/reducerHelper'
import { IReduxAction } from './index'
import { DataPromise, getDataEmptyState } from '../context/AxiosContext'
import { TaskAction, TaskOverviewDto } from '../config/taskConfig'
import { TaskListSettings } from '../components/List/Task/TaskList'
import { ActionType } from 'redux-promise-middleware'

export interface ITaskState {
    overview: DataPromise<TaskOverviewDto[], TaskListSettings>
}

const defaultState: ITaskState = {
    overview: getDataEmptyState<TaskOverviewDto[], TaskListSettings>({
        assignees: null,
        assigners: null,
        statuses: [],
    }),
}

export default function reducer(state: ITaskState = defaultState, action: IReduxAction): ITaskState {
    switch (action.type) {
        case TaskAction.OverviewSettings: {
            return getSettingsState(state, action, 'overview')
        }
        case `${TaskAction.GetOverview}_${ActionType.Pending}`: {
            return getPendingState(state, 'overview')
        }
        case `${TaskAction.GetOverview}_${ActionType.Rejected}`: {
            return getRejectedState(state, action, 'overview')
        }
        case `${TaskAction.GetOverview}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'overview')
        }
        case `${TaskAction.Add}_${ActionType.Fulfilled}`:
        case `${TaskAction.Update}_${ActionType.Fulfilled}`:
        case `${TaskAction.Delete}_${ActionType.Fulfilled}`:
        case TaskAction.ResetOverview: {
            // Reset the state to force other components to update the data.
            return resetState(state, { overview: null })
        }
    }

    return state
}
